// src/components/Disclaimer.js
import React from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  return (
    <div className="disclaimer-box">
      <h2 className="disclaimer-heading">📢 Disclaimer</h2>
      <p className="disclaimer-text">
        Applicants are advised to <strong>independently research the legitimacy</strong> of each job offer and employer before applying. We do not verify any job listing or employer.
      </p>
      <p className="disclaimer-text">
        We are <strong>not responsible</strong> for any losses, damages, or issues arising from reliance on the information provided in any job post.
      </p>
      <p className="disclaimer-text">
        By using this platform, you agree that the <strong>platform and its owners are not liable</strong> for the content posted by users.
      </p>
      <p className="disclaimer-text">
        This is a <strong>privately-owned initiative</strong> and is <strong>not affiliated with any government body or agency</strong>.
      </p>
    </div>
  );
};


export default Disclaimer;
